module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-16.2a47e8d0.png";